//Custom View 
(function ($, undefined) {
    var kendo = window.kendo,
        ui = kendo.ui,
        SchedulerView = ui.SchedulerView,
        extend = $.extend,
        NS = ".kendoYearView",
        DATA_HEADER_TEMPLATE = kendo.template("<span class='k-link k-nav-day'>#=kendo.toString(date, 'M/yyyy')#</span>"),
        EVENT_TEMPLATE = '<div class="k-task"' +
            'title="#:title.replace(/"/g,"\'")#" ' +
            'data-#=kendo.ns#uid="#=uid#"' +
            '#if (resources[0]) { #' +
            'style="color:#=resources[0].color#;"' +
            '#}#>' +
            "# if (data.isException()) { #" +
            '<span class="k-icon k-i-exception"></span>' +
            '# } else if (data.isRecurring()) {#' +
            '<span class="k-icon k-i-refresh"></span>' +
            "# } #" +
            '#:title#' +
            '#if (showDelete) {#' +
            '<a href="\\#" class="k-link k-task-delete"><span class="k-icon k-si-close"></span></a>' +
            '#}#' +
            '</div>';

    function getWorkDays(options) {
        var workDays = [];
        var dayIndex = options.workWeekStart;

        workDays.push(dayIndex);

        while (options.workWeekEnd !== dayIndex) {
            if (dayIndex > 6) {
                dayIndex -= 7;
            } else {
                dayIndex++;
            }
            workDays.push(dayIndex);
        }
        return workDays;
    }

    var counter = 0;

    var YearView = SchedulerView.extend({
        init: function (element, options) {
            var that = this;

            SchedulerView.fn.init.call(that, element, options);

            that.title = that.options.title || that.options.name;

            //get workDays to color them
            that._workDays = getWorkDays(that.options);

            that._templates();

            that._editable();
           
            //render base layout of the view
            that._renderLayout();

            element.find('.k-scheduler-layout').wrap('<div class="custom-view-table-wrapper table-responsive"></div>');
        },

        name: "year",
        
        options: {
            title: "Year",
            selectedDateFormat: "{0:D} - {1:D}",
            dateHeaderTemplate: DATA_HEADER_TEMPLATE,
            eventTemplate: EVENT_TEMPLATE
        },

        //Declaring methods to avoid errors. May be implemented if needed in the future.
        _selectEvents: function () {

        },
        _selectSlots: function (selection) {

        },
        constrainSelection: function (selection) {
        },
        //

        _editable: function () {
            var that = this;

            that.element.on("click" + NS, ".k-task a:has(.k-si-close)", function (e) {
                that.trigger("remove", { uid: $(this).closest(".k-task").attr(kendo.attr("uid")) });
                e.preventDefault();
            });

            if (that.options.editable.update !== false) {
                that.element.on("dblclick" + NS, ".k-scheduler-content td", function (e) {
                    var cell = $(this);
                    if (cell.children().length) {
                        that.trigger("edit", { uid: cell.find(".k-task").attr(kendo.attr("uid")) });
                        e.preventDefault();
                    }
                });
            }

            if (that.options.editable.create !== false) {
                that.element.on("dblclick" + NS, ".k-scheduler-content td", function (e) {
                    var cell = $(this);
                    if (!cell.children().length) {
                        var dayIndex = cell.index();
                        var startDate = kendo.date.addDays(that.startDate(), dayIndex);
                        var endDate = new Date(startDate.getTime() + (60 * 60 * 1000));
                        that.trigger("add", { eventInfo: { title: "No Title", start: startDate, end: endDate } });
                        e.preventDefault();
                    }
                });
            }
        },

        _templates: function () {
            var options = this.options;
            var settings = extend({}, kendo.Template, options.templateSettings);

            this.dateHeaderTemplate = kendo.template(options.dateHeaderTemplate, settings);
            this._eventTemplate = kendo.template(options.eventTemplate);
        },

        startDate: function () {
            return this._startDate;
        },

        endDate: function () {
            return this._endDate;
        },
        
        nextDate: function () {
            var startDate = this.startDate();
            return new Date(startDate.setFullYear(startDate.getFullYear() + 1));
        },

        previousDate: function () {
            var startDate = this.startDate();
            return new Date(startDate.setFullYear(startDate.getFullYear() - 1));
        },

        date: function (value) {
            this.options.date = value;
        },

        calculateDateRange: function () {
            var selectedDate = this.options.date;
            var start;
            if (selectedDate.toDateString() == new Date().toDateString()) {
                start = new Date(new Date().getFullYear(), 0, 1);
            }
            else {
                start = new Date(selectedDate.getFullYear(), 0, 1);
            }

            start = kendo.date.firstDayOfMonth(start);
            var idx;
            var length;
            var dates = [];

            for (idx = 0, length = 11; idx < length; idx++) {
                dates.push(start);
                newData = kendo.date.addDays(start, 31);
                var dayOfMonth = kendo.date.firstDayOfMonth(newData);
                start = kendo.date.nextDay(dayOfMonth);

                if(idx === 10) {
                    dayOfMonth = kendo.date.lastDayOfMonth(newData);
                    dates.push(dayOfMonth);
                }
            }

            return dates;
        },

        

        _renderLayout: function () {
            var dates = this.calculateDateRange();

            dates = dates || [];

            this._dates = dates;
            this._startDate = dates[0];
            this._endDate = dates[(dates.length - 1) || 0];

            this.createLayout(this._layout(dates));
        },

        _layout: function (dates) {
            var that = this;
            var columns = [];
            var options = that.options;

            for (var idx = 0; idx < dates.length; idx++) {
                var column = {};

                column.text = that.dateHeaderTemplate({
                    date: dates[idx]
                });

                if (kendo.date.isToday(dates[idx])) {
                    column.className = "k-today";
                }

                columns.push(column);
            }

            return {
                columns: columns,
                rows: []
            };
        },

        render: function (events) {
            var that = this;
            var table = that.content.find("table").empty();
            var groupsByDay = [];

            if (events.length > 0) {
                // render long events
                groupsByDay = that._longTasks(events);
                var $longTaskline = $('<tr><td class="border-0 p-0"></td></tr>');
                $longTaskline.find('td').append(that._renderLongTasks(groupsByDay, []));
                table.append($longTaskline);

                //group resources by day
                groupsByDay = that._tasks(events);
                var $taskline = $('<tr><td class="border-0 p-0"></td></tr>');
                $taskline.find('td').append(that._renderTasks(groupsByDay, []));
                table.append($taskline);
            } else {
                var tableContent = '';
                for (var dateIndex = 0; dateIndex < that._dates.length; dateIndex++) {
                    var isToday = kendo.date.isToday(that._dates[dateIndex]);
                    tableContent += '<td ' + (isToday ? 'class="k-today"' : '') + '></td>';
                }
                table.append('<tr>' + tableContent + '</tr>');
            }

            var $lines = table.filter('.k-scheduler-table').children();
            $lines.each(function () {
                var $this = $(this);
                if ($.trim($this.text()) === '') {
                    $this.addClass('no-items');
                }
            });

            that.refreshLayout();
            that.trigger("activate");
        },

        //get needed tasks from dataSource
        _tasks: function (events) {
            var tasks = [];

            for (var idx = 0; idx < events.length; idx++) {
                var event = events[idx];
                var start = event.start;
                var end = event.end;

                if (event.isAllDay) {
                    end = kendo.date.nextDay(end);
                }

                var eventDurationInDays = Math.ceil((end - start) / kendo.date.MS_PER_DAY);

                if (!event.isAllDay && eventDurationInDays === 1 && kendo.date.getDate(end).getTime() !== kendo.date.getDate(start).getTime()) {
                    eventDurationInDays += 1;
                }

                var task = event.clone();
                task.startDate = kendo.date.getDate(start);

                if (task.startDate >= this.startDate()) {
                    if (start.getFullYear() === end.getFullYear() && start.getMonth() === end.getMonth()) {
                        tasks.push(task);
                    }
                }
                
            }

            return new kendo.data.Query(tasks).sort([{
                field: "start",
                dir: "asc"
            }, {
                field: "end",
                dir: "asc"
            }]).groupBy({
                field: "startDate"
            }).toArray();
        },

        _longTasks: function (events) {
            var tasks = [];

            for (var idx = 0; idx < events.length; idx++) {
                var event = events[idx];
                var start = event.start;
                var end = event.end;

                if (event.isAllDay) {
                    end = kendo.date.nextDay(end);
                }

                var eventDurationInDays = Math.ceil((end - start) / kendo.date.MS_PER_DAY);

                if (!event.isAllDay && eventDurationInDays === 1 && kendo.date.getDate(end).getTime() !== kendo.date.getDate(start).getTime()) {
                    eventDurationInDays += 1;
                }

                var task = event.clone();
                task.startDate = kendo.date.getDate(start);

                if (start.getFullYear() !== end.getFullYear() || start.getMonth() !== end.getMonth()) {
                    tasks.push(task);
                }

            }

            return tasks;
        },
        

        _getItemsByMonthAndYear: function (month, year, tasksGroupsByDay) {
            var result = [];

            for (var groupIndex = 0; groupIndex < tasksGroupsByDay.length; groupIndex++) {
                var currentGroup = tasksGroupsByDay[groupIndex];
                for (var itemIndex = 0; itemIndex < currentGroup.items.length; itemIndex++) {
                    var currentMonth = currentGroup.items[itemIndex].startDate.getMonth();
                    var currentYear = currentGroup.items[itemIndex].startDate.getYear();
                    if (currentMonth === month && currentYear === year) {
                        result.push(currentGroup.items[itemIndex])
                    }
                }
            }

            return result;
        },

        _renderTasks: function (tasksGroupsByDay, groups) {
            var that = this;
            var tableRows = [];
            var dateGroupMapping = {};
            var maxRowCount = 0;
            var groupIndex = 0;

            maxRowCount = this._getMaxGroupCount(tasksGroupsByDay);
            
            var tbl = document.createElement('table');
            tbl.setAttribute('class', 'calendar-table');
            var tbdy = document.createElement('tbody');
            for (var rowIndex = 0; rowIndex < maxRowCount; rowIndex++) {
                var tr = document.createElement('tr');
                for (var dateIndex = 0; dateIndex < that._dates.length; dateIndex++) {
                    var currentDate = that._dates[dateIndex];
                    var isToday = kendo.date.isToday(currentDate);
                    var currentMonth = currentDate.getMonth();
                    var currentYear = currentDate.getYear();
                    var currentDates = that._getItemsByMonthAndYear(currentMonth, currentYear, tasksGroupsByDay);
                    var task = currentDates[rowIndex];
                    var htmlElement = this._generateCellContent(task, isToday);


                    tr.appendChild(htmlElement);
                }
                tbdy.appendChild(tr);
            }
            tbl.appendChild(tbdy);
            return tbl;
        },

        _renderLongTasks: function (tasksGroupsByDay, groups) {
            var that = this;
            var tableRows = [];
            var dateGroupMapping = {};
            var maxRowCount = 0;
            var groupIndex = 0;
            
            var tbl = document.createElement('table');
            tbl.setAttribute('class', 'calendar-table');
            var tbdy = document.createElement('tbody');

            for (var rowIndex = 0; rowIndex < tasksGroupsByDay.length; rowIndex++) {
                var event = tasksGroupsByDay[rowIndex];
                var startMonth, endMonth;
                var currentYear = that._dates[0].getYear();
                if (event.start.getYear() == event.end.getYear()) {
                    startMonth = event.start.getMonth();
                    endMonth = event.end.getMonth();
                }
                else if (event.start.getYear() < currentYear && event.end.getYear() > currentYear) {
                    startMonth = 0;
                    endMonth = 11;
                }
                else if (event.start.getYear() < currentYear) {
                    startMonth = 0;
                    endMonth = event.end.getMonth();
                }
                else if (event.end.getYear() > currentYear) {
                    startMonth = event.start.getMonth();
                    endMonth = 11;
                }

                var tr = document.createElement('tr');

                for (var dateIndex = 0; dateIndex < that._dates.length; dateIndex++) {
                    if (dateIndex >= startMonth && dateIndex <= endMonth) {
                        var currentDate = that._dates[dateIndex];
                        var isToday = kendo.date.isToday(currentDate);
                        var htmlElement = this._generateCellContent(event, isToday);
                        tr.appendChild(htmlElement);
                    }
                    else {
                        var currentDate = that._dates[dateIndex];
                        var isToday = kendo.date.isToday(currentDate);
                        var htmlElement = this._generateCellContent(undefined, isToday);
                        tr.appendChild(htmlElement);
                    }
                }

                tbdy.appendChild(tr);
            }
            
            tbl.appendChild(tbdy);
            return tbl;
        },
        
        _generateCellContent: function (task, isToday) {
            if (task) {
                var resources = this.eventResources(task),
                    editable = this.options.editable;

                //build data needed by template
                var templateData = extend({}, {
                    ns: kendo.ns,
                    resources: resources,
                    showDelete: editable && editable.destroy !== false
                }, task)
                
                var template = this._eventTemplate(templateData);

                var td = document.createElement('td');
                template = '<div ' +
                    (isToday ? 'class="k-today"' : '') +
                    ' style="overflow: hidden;" class="k-event" data-uid="' + task.uid + '">' +
                    template +
                    '</div>';

                td.innerHTML = template
                return td;
                
            } else {
                return document.createElement('td');
            }
        },
        
        _getMaxGroupCount: function (group) {
            var that = this;
            var maxCount = 0;

            for (var groupIndex = 0; groupIndex < group.length; groupIndex++) {
                var date = group[groupIndex].value;
                var month = date.getMonth();
                var year = date.getYear();
                var groupLength = that._getItemsByMonthAndYear(month, year, group).length;
                if (groupLength > maxCount) {
                    maxCount = groupLength;
                }
            }

            return maxCount;
        },
        
        //detach events
        destroy: function () {
            if (this.element) {
                this.element.off(NS);
            }
            ui.SchedulerView.fn.destroy.call(this);
        }
    })

    //extend UI
    extend(true, ui, {
        YearView: YearView
    });

})(window.kendo.jQuery);